import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashPromotionComponent } from './smash-promotion/smash-promotion.component';
import { SharedModule } from '@app/shared/shared.module';
import { SmashPlayerComponent } from '@app/shared/components/smash-player/smash-player.component';

@NgModule({
  declarations: [SmashPromotionComponent],
  imports: [
    CommonModule,
    SharedModule,
    SmashPlayerComponent,
  ],
  exports: [
    SmashPromotionComponent
  ]
})
export class SmashPromotionModule { }
